import { percentClient } from './percentClient'

export const capabilities = {
  percentClient
}

export type Capabilities = typeof capabilities
